module.exports = __webpack_public_path__ + "static/media/IMG_6392.15eae9bb.jpg";